import type { CustomComponentImplementation } from 'react-formatge/dist/esm/types'
import { useMemo } from 'react'
import type { GrandSelectProps, GrandSelectSimpleOption } from 'ui'
import { GrandSelect } from 'ui'

export type StepFormSelectOption = GrandSelectSimpleOption<string>

type SteFormSelectProps = CustomComponentImplementation<string> &
  Omit<GrandSelectProps<StepFormSelectOption>, 'value' | 'defaultValue'>

export const StepFormSelect = ({
  value,
  onUpdateValue,
  defaultValue,
  options,
  ...props
}: SteFormSelectProps) => {
  const defaultSelectValue = useMemo(() => {
    return defaultValue
      ? {
          label: defaultValue,
          value: defaultValue
        }
      : undefined
  }, [defaultValue])

  return (
    <GrandSelect<StepFormSelectOption>
      defaultValue={defaultSelectValue}
      onChange={(newValue) => {
        onUpdateValue?.(newValue?.value || '')
      }}
      options={options}
      styles={{
        control: (baseStyles, state) => {
          const focusColor = 'var(--chakra-colors-input-focus, var(--chakra-colors-blue-500))'

          return {
            ...baseStyles,
            borderColor: state.isFocused ? focusColor : 'transparent',
            borderRadius: 'var(--chakra-radii-lg)',
            ...(state.isFocused && { boxShadow: `0 0 0 1px ${focusColor}` }),
            '&:hover': {
              borderColor: state.isFocused ? focusColor : 'transparent'
            }
          }
        }
      }}
      {...props}
    />
  )
}
